import { ValueOf } from "../type";

export const MyInfoKey = {
  MyInfo: "MY_INFO",
} as const;

export type MyInfoKeyType = ValueOf<typeof MyInfoKey>;
